
	import { Component, Prop, Vue } from 'vue-property-decorator';

	@Component({
		components: {}
	})
	export default class AuthModal extends Vue {
		@Prop() public authUri?: string | null;
		private acceptLicense: boolean = false;

		mounted() {
			this.acceptLicense = this.licenseIsAccepted();
		}

		private login() {
			if (this.authUri) location.replace(this.authUri);
		}

		private licenseOnClick() {
			this.acceptLicense = !this.acceptLicense;
			document.cookie = 'licenseAccepted' + '=' + this.acceptLicense;
		}

		private licenseIsAccepted() {
			let value = document.cookie.match('(^|;)?' + 'licenseAccepted' + '=([^;]*)(;|$)');
			return value ? JSON.parse(unescape(value[2])) : false;
		}
	}
